import { render, staticRenderFns } from "./ListPaginator.vue?vue&type=template&id=2f4290e0&"
import script from "./ListPaginator.vue?vue&type=script&lang=js&"
export * from "./ListPaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports